import React from 'react';
import {
  FooterContainer,
  FooterWrap,
  FooterRow,
  FooterCol,
  FooterLinkTitle,
  FooterLink,
  WebsiteRights,
  SocialIcons,
  SocialIconLink,
  LogoImage
} from './FooterElements';
import { FaFacebookF } from 'react-icons/fa';
import Logo from '../../images/SoftSol_Logo_2025.png';

const Footer = () => {
  return (
    <>
      <FooterContainer>
        <FooterWrap>
          <FooterRow>
            <FooterCol>
              <FooterLinkTitle>Kontakt</FooterLinkTitle>
              <p>Software Solution</p>
              <p>Strasshoferstraße 25/1/1</p>
              <p>2620 Wartmannstetten</p>
              <p>Tel: +43 660 165 0720</p>
              <p>Email: info@softwaresolution.at</p>
            </FooterCol>

            <FooterCol>
              <FooterLinkTitle>Service</FooterLinkTitle>
              <FooterLink to="/services">IT-Pakete</FooterLink>
              <FooterLink to="/contactme">Kontaktformular</FooterLink>
              <FooterLink to="/terms">Impressum</FooterLink>
            </FooterCol>

            <FooterCol>
              <FooterLinkTitle>Social Media</FooterLinkTitle>
              <SocialIcons>
                <SocialIconLink
                  href="https://www.facebook.com/profile.php?id=61568483560094&locale=de_DE"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </SocialIconLink>
              </SocialIcons>
            </FooterCol>
          </FooterRow>

          <WebsiteRights>
            © {new Date().getFullYear()} Software Solution. Alle Rechte vorbehalten.
          </WebsiteRights>

          <LogoImage src={Logo} alt="Software Solution Logo" />
        </FooterWrap>
      </FooterContainer>
    </>
  );
};

export default Footer;
